import { Icon } from '@iconify/react';
import { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import axios from 'axios';

const addressDataList = [
  'Charles Malek Avenue, Achrafiyeh, Lebanon',
  '+961 70 080 040',
  'info@ranads.com',
];

const serviceMenuList = [
  { title: 'WhatsApp Business API Suite', href: '/service/service-details' },
  {
    title: 'Headless CMS & Websites (React)',
    href: '/service/service-details',
  },
  { title: 'React + NestJS Engineering', href: '/service/service-details' },
  { title: 'ERP Modules & Dashboards', href: '/service/service-details' },
  { title: 'AI/LLM Integrations & Copilots', href: '/service/service-details' },
  { title: 'SEO & Performance Foundations', href: '/service/service-details' },
];

const LinksMenuList = [
  { title: 'Home', href: '/' },
  { title: 'About', href: '/about' },
  { title: 'Services', href: '/service' },
  { title: 'Contact', href: '/contact' },
];

const policyMenuList = [
  { title: 'Terms of Use', href: '/terms' },
  { title: 'Privacy Policy', href: '/privacy' },
];

const socialBtnList = [
  {
    icon: 'fa6-brands:instagram',
    href: 'https://www.instagram.com/ranadsdigital',
  },
  { icon: 'fa6-brands:twitter', href: 'https://x.com/ranadsdigital' },

  {
    icon: 'fa6-brands:facebook-f',
    href: 'https://www.facebook.com/ranadsdigital',
  },
];

export default function Footer() {
  const year = new Date().getFullYear();

  // Newsletter state management
  const [email, setEmail] = useState('');
  const [emailError, setEmailError] = useState('');
  const [subscribeStatus, setSubscribeStatus] = useState(null);
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [isTouched, setIsTouched] = useState(false);

  // Validate email as user types
  useEffect(() => {
    if (isTouched) {
      validateEmail(email);
    }
  }, [email, isTouched]);

  const validateEmail = (email) => {
    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;

    if (!email) {
      setEmailError('Email is required');
      return false;
    } else if (!emailRegex.test(email)) {
      setEmailError('Please enter a valid email address');
      return false;
    } else {
      setEmailError('');
      return true;
    }
  };

  const handleEmailChange = (e) => {
    setEmail(e.target.value);
  };

  const handleEmailBlur = () => {
    setIsTouched(true);
    validateEmail(email);
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    // Final validation before submission
    if (!validateEmail(email)) {
      return;
    }

    try {
      setIsSubmitting(true);
      const baseUrl = process.env.REACT_APP_API_URL || 'http://127.0.0.1:3000';
      await axios.post(`/api/mail/newsletter/subscribe`, { email });

      setSubscribeStatus({
        success: true,
        message: 'Thank you for subscribing to our newsletter!',
      });
      setEmail('');
      setIsTouched(false);

      // Clear success message after 3 seconds
      setTimeout(() => {
        setSubscribeStatus(null);
      }, 3000);
    } catch (error) {
      console.error('Error subscribing to newsletter:', error);
      setSubscribeStatus({
        success: false,
        message: 'Failed to subscribe. Please try again later.',
      });
    } finally {
      setIsSubmitting(false);
    }
  };

  return (
    <footer
      className='cs_fooer cs_bg_filed'
      style={{ backgroundImage: 'url(/images/footer_bg.jpeg)' }}
    >
      <div className='cs_fooer_main'>
        <div className='container'>
          <div className='row'>
            {/* Brand & Address */}
            <div className='col-lg-3 col-sm-6'>
              <div className='cs_footer_item'>
                <div className='cs_text_widget'>
                  <img
                    src='/images/Horizontal_Logo-White.svg'
                    alt='Ranads Logo'
                    style={{ width: '180px' }}
                  />
                </div>
                <ul className='cs_menu_widget cs_mp0'>
                  {addressDataList.map((item, index) => (
                    <li key={index}>{item}</li>
                  ))}
                </ul>
              </div>
            </div>

            {/* Services */}
            <div className='col-lg-3 col-sm-6'>
              <div className='cs_footer_item'>
                <h2 className='cs_widget_title'>Services</h2>
                <ul className='cs_menu_widget cs_mp0'>
                  {serviceMenuList.map((item, index) => (
                    <li
                      key={index}
                      className='cursor-default opacity-80 hover:opacity-100'
                    >
                      {item.title}
                    </li>
                  ))}
                </ul>
              </div>
            </div>

            {/* Links */}
            <div className='col-lg-3 col-sm-6'>
              <div className='cs_footer_item'>
                <h2 className='cs_widget_title'>Links</h2>
                <ul className='cs_menu_widget cs_mp0'>
                  {LinksMenuList.map((item, index) => (
                    <li key={index}>
                      <Link to={item.href}>{item.title}</Link>
                    </li>
                  ))}
                </ul>
              </div>
            </div>

            {/* Newsletter */}
            <div className='col-lg-3 col-sm-6'>
              <div className='cs_footer_item'>
                <h2 className='cs_widget_title'>Subscribe Newsletter</h2>
                <div className='cs_newsletter cs_style_1'>
                  <div className='cs_newsletter_text'>
                    We only send product updates and useful reads—no spam.
                  </div>
                  <form onSubmit={handleSubmit} className='cs_newsletter_form'>
                    <input
                      type='email'
                      className={`cs_newsletter_input ${
                        emailError && isTouched ? 'error' : ''
                      }`}
                      placeholder='Email address'
                      aria-label='Email address'
                      aria-invalid={emailError ? 'true' : 'false'}
                      value={email}
                      onChange={handleEmailChange}
                      onBlur={handleEmailBlur}
                      onFocus={() => setIsTouched(true)}
                    />
                    {emailError && isTouched && (
                      <div className='cs_newsletter_error'>{emailError}</div>
                    )}
                    <button
                      className='cs_btn cs_style_1'
                      type='submit'
                      disabled={isSubmitting || (isTouched && emailError)}
                      style={{
                        opacity:
                          isSubmitting || (isTouched && emailError) ? 0.7 : 1,
                        cursor:
                          isSubmitting || (isTouched && emailError)
                            ? 'not-allowed'
                            : 'pointer',
                      }}
                    >
                      {isSubmitting ? 'Subscribing...' : 'Submit'}
                      <span>
                        <i>
                          <Icon icon='fa6-solid:arrow-right' />
                        </i>
                        <i>
                          <Icon icon='fa6-solid:arrow-right' />
                        </i>
                      </span>
                    </button>
                  </form>
                  {subscribeStatus && (
                    <div
                      className='cs_newsletter_status'
                      style={{
                        marginTop: '10px',
                        fontSize: '12px',
                        color: subscribeStatus.success ? '#4ade80' : '#f87171',
                      }}
                    >
                      {subscribeStatus.message}
                    </div>
                  )}
                </div>
              </div>
            </div>
            {/* End Newsletter */}
          </div>
        </div>
      </div>

      {/* Bottom Bar */}
      <div className='container'>
        <div className='cs_bottom_footer'>
          <div className='cs_bottom_footer_left'>
            <div className='cs_social_btns cs_style_1'>
              {socialBtnList.map((item, index) => (
                <Link
                  to={item.href}
                  className='cs_center'
                  key={index}
                  aria-label='Social link'
                >
                  <Icon icon={item.icon} />
                </Link>
              ))}
            </div>
          </div>

          <div className='cs_copyright'>
            © {year} Ranads S.A.R.L. All rights reserved.
          </div>

          <div className='cs_bottom_footer_right'>
            <ul className='cs_footer_links cs_mp0'>
              {policyMenuList.map((item, index) => (
                <li key={index}>
                  <Link to={item.href}>{item.title}</Link>
                </li>
              ))}
            </ul>
          </div>
        </div>
      </div>
    </footer>
  );
}
